/* eslint-disable default-param-last */
import { types } from "../types/types";

const ini = {
  jwt: "",
  refreshToken: "",
  user: {
    email: "",
    firstName: "",
    mobile_phone: "",
    city: "",
    address: "",
    termsAgreed: false,
    deliveryCity: "",
    deliveryAddress: "",
    deliveryDistrict: "",
    deliveryNotes: "",
    deliveryTime: "AM",
  },
  tempToken: "",
};

export const userReducer = (state = ini, action: any) => {
  switch (action.type) {
    case types.user:
      return {
        ...state,
        jwt: action.payload.jwt,
        refreshToken: action.payload.refreshToken
      };
    case types.userDt:
      return {
        ...state,
        user: action.payload.user,
      };
    case types.setTempToken:
      return {
        ...ini,
        tempToken: action.payload.tempToken,
      };
    case types.logout:
      return ini;
    default:
      return state;
  }
};
